import {Component, OnInit} from '@angular/core';
import {GamesPlaygroundService} from "../../service/games-playground/games-playground.service";
import {LoaderService} from "../../service/loader.service";
import {UserBalanceService} from "../../service/users/userBalance.service";
import {PopupComponent} from "../../shared/popup/popup.component";
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {Router} from "@angular/router";
import {RouterPaths} from "../../config/router-paths.model";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  gamesImitation = [
    {
      "name": "FIREKIRIN",
      "short_name": "firekirin",
      "id": 11,
      "default": false
    },
    {
      "name": "JUWA",
      "short_name": "juwa",
      "id": 13,
      "default": false
    },
    {
      "name": "PANDA",
      "short_name": "panda",
      "id": 12,
      "default": false
    },
    {
      "name": "RIVER",
      "short_name": "river",
      "id": 1,
      "default": false
    },
    {
      "name": "SENET",
      "short_name": "senet",
      "id": 9,
      "default": false
    },
    {
      "name": "ULTRA PANDA",
      "short_name": "ultrapanda",
      "id": 15,
      "default": false
    },
    {
      "name": "VBLINK",
      "short_name": "vblink",
      "id": 14,
      "default": false
    },
    {
      "name": "Golden dragon",
      "short_name": "gd",
      "id": 2,
      "default": true
    }
  ];
  games = [];

  constructor(private gamesPlaygroundService: GamesPlaygroundService,
              private userBalanceService: UserBalanceService,
              private popupComponent: PopupComponent,
              private router: Router,
              private authenticationService: AuthenticationService,
              private loaderService: LoaderService) {
    this.authenticationService.userLoggedIn.subscribe(val => {
      this.getPageInfo();
      this.gamesPlaygroundService.onGamesUpdated.emit(Math.random());
    });
    this.gamesPlaygroundService.updateGames.subscribe(val => {
      this.getPageInfo(false, val);
    });
  }

  ngOnInit(): void {
    this.loaderService.show();
    this.getPageInfo();
  }

  isUserLogged() {
    return !!this.authenticationService.getCurrentUser()
  }

  getPageInfo(withBalance = true, gameShortName?) {
    if (this.isUserLogged()) {
      this.gamesPlaygroundService.getPageInfo(gameShortName).subscribe(data => {
        try {
          try {
            this.games = data.games.filter(game => !game.default);
            this.gamesPlaygroundService.setGames(data.games);

            this.gamesPlaygroundService.onGamesUpdated.emit(Math.random());

            this.scrollTopOnGameChange();

            if (withBalance) {
              this.getBalance();
            }
          } catch (e) {
            this.loaderService.hideAndShowTryAgain();
          }
        } catch (e) {
          this.loaderService.hideAndShowTryAgain();
        }
      }, () => {
        this.loaderService.hideAndShowTryAgain();
      }, () => {
        this.loaderService.hide();
      });
    } else {
      if (gameShortName) {
        this.gamesImitation.map(game => {game.default = game.short_name === gameShortName;});
        this.scrollTopOnGameChange();
      }
      this.games = this.gamesImitation.filter(game => !game.default);
      this.gamesPlaygroundService.setGames(this.gamesImitation);
      this.loaderService.hide();
    }
  }

  scrollTopOnGameChange() {
    const element = document.getElementById('mainTabs');
    if (document.getElementById('mainTabs')) {
      element.scrollIntoView({behavior: "smooth", block: "start"});
    }
  }

  getBalance() {
    this.userBalanceService.getBalance().subscribe(data => {
        this.userBalanceService.updateBalance(data.entries, data.spend);
    }, () => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      this.loaderService.hide();
    });
  }

  hideTabs() {
    return this.router.url === '/' + RouterPaths.termsAndConditions
  }
}
